<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="Payment">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>
        </div>
        <div v-if="pay_info">
            <div class="top-wrapper">
                <div class="row-wrapper title-wrapper">
                    <i class="icon iconfont">&#xe6d2;</i>
                    <label class="title">The order is submitted successfully, please select the payment method</label>
                </div>
                <div class="row-wrapper subtitle-wrapper">
                    <label class="subtitle">Total:</label>
                    <label class="price">$ {{pay_info.pay_amount}}</label>
                </div>
            </div>
            <mt-cell title="Pre-deposit" v-if="showBalancePayment && pay_info.member_available_pd>0">${{pay_info.member_available_pd}}<mt-switch v-model="payment_info.pd_pay" :disabled="stripeInstallmentSelected"></mt-switch></mt-cell>
            <mt-cell title="Recharge card" v-if="showBalancePayment && pay_info.member_available_rcb>0">${{pay_info.member_available_rcb}}<mt-switch v-model="payment_info.rcb_pay" :disabled="stripeInstallmentSelected"></mt-switch></mt-cell>
            <div class="item-wrapper" v-on:click="payType(item.payment_code)" v-for="(item,index) in visiblePaymentList" :key="index">
                <div class="item-left-wrapper">
                    <span class="stripe-list-logo" v-if="item.payment_code === 'stripe_h5'">stripe</span>
                    <i :class="setClass(item.payment_code)" v-else></i>
                    <label class="item-title">{{item.payment_code === 'stripe_h5' ? 'Stripe H5 (Test Mode)' : item.payment_name}}</label>
                </div>
                <div class="item-right-wrapper">
                    <i class="item-select iconfont" v-if="payment_info.payment_code == item.payment_code">&#xe69d;</i>
                </div>
            </div>

            <div class="stripe-payment-options" v-if="isStripe">
                <template v-if="pay_type === 'pay_new'">
                    <div class="stripe-progress-panel" v-if="stripe_plan && stripe_plan.items && stripe_plan.items.length">
                        <div class="stripe-section-heading">
                            <h4>Installment progress</h4>
                            <span>{{stripePlanPaidPercent}}% paid</span>
                        </div>
                        <div class="stripe-progress-track" role="progressbar" aria-label="Stripe installment payment progress" aria-valuemin="0" aria-valuemax="100" :aria-valuenow="stripePlanPaidPercent">
                            <span class="stripe-progress-fill" :style="{width: stripePlanPaidPercent + '%'}"></span>
                        </div>
                        <div class="stripe-plan-items">
                            <div
                                class="stripe-plan-item"
                                :class="{
                                    'stripe-plan-item-paid': item.status === 'paid',
                                    'stripe-plan-item-current': item.status !== 'paid' && item.phase_no == stripe_plan.current_phase
                                }"
                                v-for="item in stripe_plan.items"
                                :key="item.phase_no"
                            >
                                <span class="stripe-plan-index">{{item.phase_no}}</span>
                                <div class="stripe-plan-copy">
                                    <span>Installment {{item.phase_no}} · {{item.ratio}}%</span>
                                    <strong>{{formatStripeAmount(item.amount_minor, stripe_plan.currency)}}</strong>
                                </div>
                                <span class="stripe-plan-status">{{item.status === 'paid' ? 'Paid' : (item.phase_no == stripe_plan.current_phase ? 'Due now' : 'Pending')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="stripe-plan-setup" v-else>
                        <h4>Stripe payment plan</h4>
                        <label class="stripe-mode-option">
                            <input type="radio" value="full" v-model="stripe_payment_mode"> Pay in full
                        </label>
                        <label class="stripe-mode-option">
                            <input type="radio" value="installment" v-model="stripe_payment_mode"> Pay in installments
                        </label>
                        <div class="stripe-installment-config" v-if="stripe_payment_mode === 'installment'">
                            <p>Each installment is paid manually through Stripe. The order is marked paid after the final installment.</p>
                            <label>
                                Number of installments
                                <select v-model.number="stripe_phase_count">
                                    <option :value="2">2 installments</option>
                                    <option :value="3">3 installments</option>
                                </select>
                            </label>
                            <label>
                                Installment 1
                                <select v-model.number="stripe_phase_1_ratio">
                                    <option v-for="ratio in stripeRatioOptions" :key="ratio" :value="ratio">{{ratio}}%</option>
                                </select>
                            </label>
                            <label v-if="stripe_phase_count === 3">
                                Installment 2
                                <select v-model.number="stripe_phase_2_ratio">
                                    <option v-for="ratio in stripeRatioOptions" :key="ratio" :value="ratio">{{ratio}}%</option>
                                </select>
                            </label>
                            <p class="stripe-installment-preview" :class="{'stripe-inline-error': !stripeInstallmentValid}">{{stripeInstallmentPreview}}</p>
                        </div>
                    </div>
                </template>
                <div class="stripe-checkout-panel">
                    <div class="stripe-current-payment" v-if="stripe_amount_minor > 0">
                        <div>
                            <span class="stripe-current-label">{{stripeInstallmentSelected ? 'Current installment' : 'Payment amount'}}</span>
                            <strong>{{formatStripeAmount(stripe_amount_minor, stripe_currency)}}</strong>
                            <small v-if="stripe_plan">Installment {{stripe_plan.current_phase}} of {{stripe_plan.items.length}}</small>
                        </div>
                        <span class="stripe-due-badge">Due now</span>
                    </div>
                    <div class="stripe-card-panel">
                        <h4>Card information</h4>
                        <p class="stripe-inline-hint">Your card information is securely collected by Stripe on this page.</p>
                        <div id="stripe_payment_element"></div>
                        <div class="stripe-payment-message" :class="{'stripe-inline-error': stripe_error}" role="alert">{{stripe_message}}</div>
                    </div>
                </div>
            </div>
        </div>
        <mt-button class="ds-button-large" type="primary" v-on:click="submit" :disabled="stripeButtonDisabled">{{submitLabel}}</mt-button>

        <!--修改邮箱-->
        <mt-popup v-model="editEmailVisible" position="right" class="common-popup-wrapper">
          <div class="common-header-wrap">
            <mt-header :title="'Modify E-mail'" class="common-header">
              <mt-button slot="left" icon="back" @click="editEmailVisible=false"></mt-button>
            </mt-header>
          </div>
          <div class="common-popup-content">
            <mt-field class="menu-item" label="E-mail" type="text" v-model="email" />
            <mt-button class="ds-button-large"  type="primary" @click='sendVerifyCodeEmail' >Submit</mt-button>
          </div>
        </mt-popup>

    </div>
</template>

<script>
/* global uni, wx */
import { getOrderpayInfo } from '../../../api/memberBuy'
import { getVrOrderpayInfo } from '../../../api/memberVrBuy'
import { mapState } from 'vuex'
import { pay, getPaymentList, createStripeSession, getStripeState } from '../../../api/memberPayment'
import { getRechargeInfo } from '../../../api/memberRecharge'
import { Toast, MessageBox } from 'mint-ui'
import { loadScript } from '../../../util/common'
import { updateUserEmail } from '@/api/memberSetting'
export default {
  name: 'pay',
  data () {
    return {
      uniapp: 0,
      pay_sn: this.$route.query.pay_sn ? this.$route.query.pay_sn : '',
      pay_type: this.$route.query.pay_type ? this.$route.query.pay_type : '',
      // 订单支付显示的数据
      pay_info: null,
      // 提交支付需要用到的数据
      payment_info: {
        password: '', // 支付密码
        rcb_pay: 0, // 是否使用充值卡进行支付
        pd_pay: 0, // 是否使用预存款进行支付
        payment_code: 'alipay_h5' // 支付方式

      },
      showBalancePayment: false, // 暂时隐藏余额和充值卡组合支付入口
      payment_list: [],
      showNotice: 0,
      notice: this.$route.query.notice,
      ifLoaded: false,
      email: '',
      editEmailVisible: false,
      stripe_payment_mode: 'full',
      stripe_phase_count: 2,
      stripe_phase_1_ratio: 30,
      stripe_phase_2_ratio: 30,
      stripeRatioOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90],
      stripe_plan: null,
      stripe_state: 'idle',
      stripe_message: '',
      stripe_error: false,
      stripe_can_confirm: false,
      stripe_amount_minor: 0,
      stripe_currency: 'usd',
      stripe_checkout: null,
      stripe_actions: null,
      stripe_element: null,
      stripe_generation: 0,
      stripe_restoring: false,
      stripe_auto_load_timer: null,
      stripe_poll_timer: null,
      stripe_poll_attempts: 0,
      stripe_script_timer: null
    }
  },
  computed: {
    ...mapState({
      token: state => state.member.token
    }),
    isStripe () {
      return this.payment_info.payment_code === 'stripe_h5'
    },
    stripeInstallmentLocked () {
      return !!(this.stripe_plan && this.stripe_plan.items && this.stripe_plan.items.length && this.stripe_plan.status !== 'paid')
    },
    visiblePaymentList () {
      if (!this.stripeInstallmentLocked) return this.payment_list
      return this.payment_list.filter(item => item.payment_code === 'stripe_h5')
    },
    stripeInstallmentSelected () {
      return this.isStripe && this.pay_type === 'pay_new' && (
        (this.stripe_plan && this.stripe_plan.items && this.stripe_plan.items.length) ||
        this.stripe_payment_mode === 'installment'
      )
    },
    stripeInstallmentValid () {
      if (this.stripe_phase_count === 2) {
        return this.stripe_phase_1_ratio >= 10 && this.stripe_phase_1_ratio <= 90
      }
      return this.stripe_phase_1_ratio >= 10 && this.stripe_phase_2_ratio >= 10 &&
        (100 - this.stripe_phase_1_ratio - this.stripe_phase_2_ratio) >= 10
    },
    stripeInstallmentPreview () {
      if (!this.pay_info || this.stripe_payment_mode !== 'installment') return ''
      if (!this.stripeInstallmentValid) {
        return 'The first two installments must leave at least 10% for the final installment.'
      }
      let total = Math.round(parseFloat(this.pay_info.pay_amount || 0) * 100)
      let first = Math.round(total * this.stripe_phase_1_ratio / 100)
      if (this.stripe_phase_count === 2) {
        return 'Installment 1: ' + this.formatStripeAmount(first, 'usd') +
          ' (' + this.stripe_phase_1_ratio + '%); Installment 2: ' +
          this.formatStripeAmount(total - first, 'usd') + ' (' + (100 - this.stripe_phase_1_ratio) + '%)'
      }
      let second = Math.round(total * this.stripe_phase_2_ratio / 100)
      let thirdRatio = 100 - this.stripe_phase_1_ratio - this.stripe_phase_2_ratio
      return 'Installment 1: ' + this.formatStripeAmount(first, 'usd') +
        ' (' + this.stripe_phase_1_ratio + '%); Installment 2: ' +
        this.formatStripeAmount(second, 'usd') + ' (' + this.stripe_phase_2_ratio + '%); Installment 3: ' +
        this.formatStripeAmount(total - first - second, 'usd') + ' (' + thirdRatio + '%)'
    },
    stripePlanPaidPercent () {
      if (!this.stripe_plan || !parseInt(this.stripe_plan.total_amount_minor || 0, 10)) return 0
      let paid = parseInt(this.stripe_plan.paid_amount_minor || 0, 10)
      let total = parseInt(this.stripe_plan.total_amount_minor || 0, 10)
      return Math.max(0, Math.min(100, Math.round(paid * 100 / total)))
    },
    stripeButtonDisabled () {
      return this.isStripe && (
        this.stripe_state === 'loading' ||
        this.stripe_state === 'processing' ||
        (this.stripe_state === 'ready' && !this.stripe_can_confirm)
      )
    },
    submitLabel () {
      if (!this.isStripe) return 'Immediate payment'
      if (this.stripe_state === 'loading') return 'Loading secure card form...'
      if (this.stripe_state === 'processing') return 'Processing payment...'
      if (this.stripe_state === 'ready' && this.stripe_amount_minor > 0) {
        let amount = this.formatStripeAmount(this.stripe_amount_minor, this.stripe_currency)
        if (this.stripeInstallmentSelected) {
          let phase = this.stripe_plan ? this.stripe_plan.current_phase : 1
          return 'Pay installment ' + phase + ' - ' + amount
        }
        return 'Confirm payment - ' + amount
      }
      return 'Load secure card form'
    }
  },
  created: function () {
    let _this = this
    loadScript('uniapp', 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js', function () {
      uni.getEnv(function (res) {
        _this.ifLoaded = true
        if (res.plus) {
          _this.uniapp = 1
        }
      })
    })

    this.getMemberPayInfo()
  },
  watch: {
    showNotice: function (val) {
      if (val && this.notice) {
        MessageBox.confirm('If you have completed the payment, please click the "Complete Payment" button, if you have not completed the payment, please click "Repay" to initiate the payment again', 'Confirm whether the payment is complete', { cancelButtonText: 'Pay again', confirmButtonText: 'Payment completed' }).then(action => {
          this.goNext()
        })
      }
    },
    ifLoaded: function (val) {
      if (val) {
        this.getPaymentList()
      }
    },
    stripe_payment_mode: function () {
      if (this.stripe_payment_mode === 'installment') {
        this.payment_info.pd_pay = 0
        this.payment_info.rcb_pay = 0
      }
      this.stripeOptionsChanged()
    },
    stripe_phase_count: function () {
      this.stripeOptionsChanged()
    },
    stripe_phase_1_ratio: function () {
      this.stripeOptionsChanged()
    },
    stripe_phase_2_ratio: function () {
      this.stripeOptionsChanged()
    },
    'payment_info.pd_pay': function () {
      this.stripeBalanceChanged()
    },
    'payment_info.rcb_pay': function () {
      this.stripeBalanceChanged()
    }
  },
  beforeDestroy () {
    this.stopStripeAutoLoad()
    this.stopStripePolling()
    this.resetStripe()
  },
  methods: {
    goBack () {
      if (this.notice) {
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    },
    setClass (code) {
      let obj = {}
      obj['icon ' + code] = true
      return obj
    },
    goNext () {
      if (this.pay_type === 'pay_new') {
        this.$router.push({ name: 'MemberOrderList' })
      } else if (this.pay_type === 'vr_pay_new') {
        this.$router.push({ name: 'MemberVrOrderList' })
      } else if (this.pay_type === 'pd_pay') {
        this.$router.push({ name: 'MemberRechargeList' })
      }
    },
    payType (code) {
      if (this.stripeInstallmentLocked && code !== 'stripe_h5') {
        Toast('Please continue this installment plan with Stripe')
        return
      }
      if (this.payment_info.payment_code === code) return
      let wasStripe = this.isStripe
      this.payment_info.payment_code = code
      if (wasStripe && code !== 'stripe_h5') {
        this.stopStripeAutoLoad()
        this.resetStripe()
        return
      }
      if (code === 'stripe_h5') {
        this.initializeStripePayment()
      }
    },
    formatStripeAmount (amountMinor, currency) {
      let value = (parseInt(amountMinor || 0, 10) / 100).toFixed(2)
      let currencyCode = String(currency || 'usd').toLowerCase()
      return currencyCode === 'usd' ? '$' + value : currencyCode.toUpperCase() + ' ' + value
    },
    stripeOptionsChanged () {
      if (this.stripe_restoring || !this.isStripe || this.stripe_plan) return
      this.resetStripe()
      if (this.stripe_payment_mode !== 'installment' || this.stripeInstallmentValid) {
        this.prepareStripe(350)
      }
    },
    stripeBalanceChanged () {
      if (this.stripe_restoring || !this.isStripe || this.stripeInstallmentSelected) return
      this.resetStripe()
      if (!this.payment_info.pd_pay && !this.payment_info.rcb_pay) {
        this.prepareStripe(350)
      } else {
        this.setStripeMessage('Enter the payment password, then load the secure card form.')
      }
    },
    initializeStripePayment (stateLoaded) {
      if (!this.pay_info || !this.isStripe) return
      let statePromise = stateLoaded ? Promise.resolve() : this.loadStripeState()
      statePromise.then(() => {
        if (!this.isStripe) return
        if (this.stripe_plan && this.stripe_plan.status !== 'paid') {
          this.stripe_restoring = true
          this.stripe_payment_mode = 'installment'
          this.payment_info.pd_pay = 0
          this.payment_info.rcb_pay = 0
        }
        if ((this.payment_info.pd_pay || this.payment_info.rcb_pay) && !this.payment_info.password) {
          this.stripe_restoring = false
          this.setStripeMessage('Enter the payment password, then load the secure card form.')
          return
        }
        this.$nextTick(() => {
          this.stripe_restoring = false
          this.scheduleStripeAutoLoad(150)
        })
      }).catch(error => {
        this.stripe_restoring = false
        this.setStripeMessage(error.message || 'Unable to initialize Stripe payment.', true)
      })
    },
    scheduleStripeAutoLoad (delay) {
      this.stopStripeAutoLoad()
      this.stripe_auto_load_timer = setTimeout(() => {
        this.stripe_auto_load_timer = null
        if (!this.isStripe || !this.pay_info || !this.payment_list.length) return
        if (this.stripe_state !== 'idle' || this.stripe_element || this.stripe_actions) return
        this.prepareStripe(0)
      }, Math.max(0, parseInt(delay || 0, 10)))
    },
    stopStripeAutoLoad () {
      if (this.stripe_auto_load_timer) {
        clearTimeout(this.stripe_auto_load_timer)
        this.stripe_auto_load_timer = null
      }
    },
    syncStripePaymentStatus () {
      if (!this.pay_info || !this.payment_list.length) return
      let stripeAvailable = this.payment_list.some(item => item.payment_code === 'stripe_h5')
      if (!stripeAvailable && !this.$route.query.stripe_return) return
      this.loadStripeState().then(() => {
        if (this.$route.query.stripe_return) {
          if (stripeAvailable) {
            this.payment_info.payment_code = 'stripe_h5'
          }
          let returnedSessionId = String(this.$route.query.session_id || '')
          let currentSessionId = this.stripe_plan ? String(this.stripe_plan.current_session_id || '') : ''
          let installmentAdvanced = !!(this.stripe_plan && returnedSessionId && currentSessionId !== returnedSessionId)
          if (installmentAdvanced && this.isStripe) {
            this.initializeStripePayment(true)
          } else {
            this.startStripePolling()
          }
        } else if (this.isStripe) {
          this.initializeStripePayment(true)
        }
      })
    },
    loadStripeState () {
      return getStripeState(this.pay_sn, this.pay_type).then(res => {
        if (res.result.state) {
          this.goNext()
          return
        }
        this.stripe_plan = res.result.stripe_plan && res.result.stripe_plan.items && res.result.stripe_plan.items.length
          ? res.result.stripe_plan
          : null
        if (this.stripe_plan && this.stripe_plan.status !== 'paid') {
          this.payment_info.payment_code = 'stripe_h5'
        }
      }).catch(error => {
        this.setStripeMessage(error.message || 'Unable to load Stripe payment status.', true)
      })
    },
    stripeOrderType () {
      if (this.pay_type === 'vr_pay_new') return 'vr_order'
      if (this.pay_type === 'pd_pay') return 'pd_order'
      return 'real_order'
    },
    stripeRequestData () {
      return {
        pay_sn: this.pay_sn,
        order_type: this.stripeOrderType(),
        password: this.payment_info.password,
        rcb_pay: this.payment_info.rcb_pay ? 1 : 0,
        pd_pay: this.payment_info.pd_pay ? 1 : 0,
        stripe_payment_mode: this.stripe_plan ? 'installment' : this.stripe_payment_mode,
        stripe_phase_count: this.stripe_phase_count,
        stripe_phase_1_ratio: this.stripe_phase_1_ratio,
        stripe_phase_2_ratio: this.stripe_phase_2_ratio
      }
    },
    setStripeMessage (message, isError) {
      this.stripe_message = message || ''
      this.stripe_error = !!isError
    },
    loadStripeScript () {
      return new Promise((resolve, reject) => {
        if (typeof window.Stripe === 'function') {
          resolve()
          return
        }
        let done = false
        let finish = (error) => {
          if (done) return
          done = true
          if (this.stripe_script_timer) {
            clearTimeout(this.stripe_script_timer)
            this.stripe_script_timer = null
          }
          error ? reject(error) : resolve()
        }
        loadScript('stripe_checkout', 'https://js.stripe.com/clover/stripe.js', function () {
          if (typeof window.Stripe === 'function') {
            finish()
          } else {
            finish(new Error('Stripe.js failed to load.'))
          }
        })
        this.stripe_script_timer = setTimeout(function () {
          finish(new Error('Stripe.js loading timed out. Please check the network and try again.'))
        }, 12000)
      })
    },
    prepareStripe (delay) {
      if (!this.isStripe || !this.pay_info || this.stripe_state === 'processing') return
      if (this.stripe_payment_mode === 'installment' && !this.stripe_plan && !this.stripeInstallmentValid) {
        this.setStripeMessage(this.stripeInstallmentPreview, true)
        return
      }
      let generation = ++this.stripe_generation
      this.stripe_state = 'loading'
      this.stripe_can_confirm = false
      this.setStripeMessage('Preparing the secure card form...')
      setTimeout(() => {
        if (generation !== this.stripe_generation || !this.isStripe) return
        this.loadStripeScript().then(() => {
          return createStripeSession(this.stripeRequestData())
        }).then(res => {
          if (generation !== this.stripe_generation || !this.isStripe) return
          if (res.result.paid_locally) {
            this.goNext()
            return
          }
          this.stripe_amount_minor = parseInt(res.result.amount_minor || 0, 10)
          this.stripe_currency = res.result.currency || 'usd'
          if (res.result.stripe_plan && res.result.stripe_plan.items && res.result.stripe_plan.items.length) {
            this.stripe_plan = res.result.stripe_plan
          }
          let stripe = window.Stripe(res.result.publishable_key, {
            developerTools: {
              assistant: {
                enabled: false
              }
            }
          })
          this.stripe_checkout = stripe.initCheckout({
            clientSecret: res.result.client_secret,
            elementsOptions: {
              appearance: {
                theme: 'stripe',
                variables: {
                  colorPrimary: '#635bff',
                  borderRadius: '6px'
                }
              }
            }
          })
          this.stripe_checkout.on('change', session => {
            if (generation !== this.stripe_generation) return
            this.stripe_can_confirm = !!(session && session.canConfirm)
          })
          return this.stripe_checkout.loadActions()
        }).then(loadResult => {
          if (!loadResult || generation !== this.stripe_generation || !this.isStripe) return
          if (loadResult.type !== 'success') {
            throw new Error(loadResult.error ? loadResult.error.message : 'Unable to load Stripe Checkout.')
          }
          this.stripe_actions = loadResult.actions
          this.stripe_element = this.stripe_checkout.createPaymentElement()
          this.stripe_element.on('ready', () => {
            if (generation !== this.stripe_generation) return
            this.stripe_state = 'ready'
            let currentSession = this.stripe_actions.getSession()
            this.stripe_can_confirm = !!(currentSession && currentSession.canConfirm)
            this.setStripeMessage('Card details are encrypted and sent directly to Stripe.')
          })
          this.stripe_element.on('loaderror', event => {
            if (generation !== this.stripe_generation) return
            let message = event && event.error && event.error.message
              ? event.error.message
              : 'The secure card form failed to load.'
            this.resetStripe()
            this.setStripeMessage(message, true)
          })
          this.$nextTick(() => {
            if (generation === this.stripe_generation && this.stripe_element) {
              this.stripe_element.mount('#stripe_payment_element')
            }
          })
        }).catch(error => {
          if (generation !== this.stripe_generation) return
          if (error.message && error.message.toLowerCase().indexOf('password') !== -1) {
            this.payment_info.password = ''
          }
          this.resetStripe()
          this.setStripeMessage(error.message || 'Unable to initialize Stripe payment.', true)
        })
      }, Math.max(0, parseInt(delay || 0, 10)))
    },
    resetStripe () {
      this.stripe_generation++
      if (this.stripe_element && typeof this.stripe_element.unmount === 'function') {
        try {
          this.stripe_element.unmount()
        } catch (error) {
          // The Stripe element may already be detached during route changes.
        }
      }
      this.stripe_checkout = null
      this.stripe_actions = null
      this.stripe_element = null
      this.stripe_can_confirm = false
      this.stripe_amount_minor = 0
      if (this.stripe_state !== 'processing') {
        this.stripe_state = 'idle'
      }
    },
    confirmStripePayment () {
      if (this.stripe_state !== 'ready' || !this.stripe_actions) {
        this.prepareStripe(0)
        return
      }
      if (!this.stripe_can_confirm) {
        this.setStripeMessage('Please complete the card information before paying.', true)
        return
      }
      this.stripe_state = 'processing'
      this.setStripeMessage('')
      this.stripe_actions.confirm().then(result => {
        if (result && result.type === 'error') {
          this.stripe_state = 'ready'
          this.setStripeMessage(result.error && result.error.message ? result.error.message : 'Payment failed. Please check your card details.', true)
          return
        }
        this.setStripeMessage('Payment submitted. Waiting for confirmation from Stripe...')
        this.startStripePolling()
      }).catch(error => {
        this.stripe_state = 'ready'
        this.setStripeMessage(error.message || 'Payment failed. Please try again.', true)
      })
    },
    startStripePolling () {
      this.stopStripePolling()
      this.stripe_poll_attempts = 0
      let previousPhase = this.stripe_plan ? this.stripe_plan.current_phase : 0
      let previousPaid = this.stripe_plan ? this.stripe_plan.paid_amount_minor : 0
      let check = () => {
        this.stripe_poll_attempts++
        getStripeState(this.pay_sn, this.pay_type).then(res => {
          if (res.result.state) {
            this.stopStripePolling()
            Toast('Payment successful')
            this.goNext()
            return
          }
          let plan = res.result.stripe_plan
          if (plan && plan.items && plan.items.length &&
              (plan.current_phase !== previousPhase || plan.paid_amount_minor !== previousPaid)) {
            this.stopStripePolling()
            this.stripe_plan = plan
            this.stripe_state = 'idle'
            Toast('Installment payment confirmed')
            this.resetStripe()
            this.$nextTick(() => this.prepareStripe(0))
          } else if (this.stripe_poll_attempts >= 30) {
            this.stopStripePolling()
            this.stripe_state = 'idle'
            this.setStripeMessage('Payment was submitted. The status is still being confirmed; please refresh later.')
          }
        }).catch(() => {
          if (this.stripe_poll_attempts >= 30) {
            this.stopStripePolling()
            this.stripe_state = 'idle'
            this.setStripeMessage('Unable to confirm the payment status. Please refresh later.', true)
          }
        })
      }
      check()
      this.stripe_poll_timer = setInterval(check, 1000)
    },
    stopStripePolling () {
      if (this.stripe_poll_timer) {
        clearInterval(this.stripe_poll_timer)
        this.stripe_poll_timer = null
      }
    },
    getPaymentList () {
      let _this = this

      getPaymentList(this.uniapp).then(res => {
        this.payment_list = res.result.payment_list
        const stripeIndex = this.payment_list.findIndex(item => item.payment_code === 'stripe_h5')
        if (stripeIndex > 0) {
          this.payment_list.unshift(this.payment_list.splice(stripeIndex, 1)[0])
        }
        if (this.payment_list.length) {
          this.payment_info.payment_code = this.payment_list[0].payment_code
        }
        this.syncStripePaymentStatus()
        loadScript('weixin', 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js', function () {
          wx.miniProgram.getEnv(function (res) {
            for (var i in _this.payment_list) {
              if (res.miniprogram) {
                if (_this.payment_list[i].payment_code === 'wxpay_jsapi') {
                  _this.payment_list.splice(i, 1)
                  break
                }
              } else {
                if (_this.payment_list[i].payment_code === 'wxpay_minipro') {
                  _this.payment_list.splice(i, 1)
                  break
                }
              }
            }
          })
        })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    getMemberPayInfo () {
      if (this.pay_type === 'pay_new') {
        let _this = this
        getOrderpayInfo(
          this.pay_sn
        ).then((res) => {
          if (res.code === 10000) {
            this.pay_info = res.result.pay_info
            this.syncStripePaymentStatus()
          }
          this.showNotice = 1
        }).catch(error => {
          if (error.code === 12001) { // 订单已经支付
            _this.goNext()
          } else {
            Toast(error.message)
          }
        })
      } else if (this.pay_type === 'vr_pay_new') {
        getVrOrderpayInfo(
          this.pay_sn
        ).then((res) => {
          if (res.code === 10000) {
            this.pay_info = res.result.pay_info
            this.syncStripePaymentStatus()
          }
          this.showNotice = 1
        }).catch(error => {
          if (error.code === 12001) { // 订单已经支付
            this.goNext()
          } else {
            Toast(error.message)
          }
        })
      } else if (this.pay_type === 'pd_pay') {
        getRechargeInfo(
          this.pay_sn
        ).then((res) => {
          if (res.code === 10000) {
            this.pay_info = { pay_amount: res.result.pdinfo.pdr_amount }
            this.syncStripePaymentStatus()
          }
          this.showNotice = 1
        }).catch(error => {
          if (error.code === 12001) { // 订单已经支付
            this.goNext()
          } else {
            Toast(error.message)
          }
        })
      }
    },
    submit () {
      if (this.payment_info.pd_pay || this.payment_info.rcb_pay) {
        if (!this.pay_info.member_paypwd) {
          MessageBox.confirm(
            'You need to set up a payment password first',
            'Tip',
            {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel'
            }
          ).then(action => {
            this.$router.push({ name: 'MemberSetting' })
          })
          return
        } else {
          if (!this.payment_info.password) {
            MessageBox.prompt('<b>Please enter payment password</b><br/>Note: The default payment password is: 123456', '', {
              showCancelButton: true,
              inputType: 'password'
            }).then(({ value, action }) => {
              this.payment_info.password = value
              this.submit()
            })
            return
          }
        }
      }
      if (this.isStripe) {
        if (this.stripeInstallmentSelected && !this.stripe_plan && !this.stripeInstallmentValid) {
          this.setStripeMessage(this.stripeInstallmentPreview, true)
          return
        }
        this.confirmStripePayment()
        return
      }
      var param = 'action=' + this.pay_type + '&key=' + this.token + '&pay_sn=' + this.pay_sn + '&password=' + this.payment_info.password + '&rcb_pay=' + this.payment_info.rcb_pay + '&pd_pay=' + this.payment_info.pd_pay + '&payment_code=' + this.payment_info.payment_code
      if (this.payment_info.payment_code === 'wxpay_minipro') {
        wx.miniProgram.redirectTo({ url: '../pay/pay?' + param })
        return
      }
      if (this.uniapp) {
        uni.redirectTo({ url: 'pay?' + param })
        return
      }
      pay(
        this.pay_sn, this.pay_type, this.payment_info, this.token, this.uniapp
      ).then((res) => {
        if (this.payment_info.payment_code === 'pingpong_h5') {
          if (res.code) {
            if (res.code === 10000) {
              window.location.href = res.result
            } else {
              if (res.message === 'Need to bind email') {
                var that = this

                // Toast(res.message)
                // setTimeout(function () {
                //   that.$router.push({ name: 'MemberSetting' })
                // }, 2000)

                // 弹窗修改邮件地址
                that.editEmailVisible = true
              } else {
                Toast(res.message)
              }
            }
          }
        } else {
          if (res.code) {
            if (res.code === 10000 || res.code === 12001) {
              this.goNext()
            } else {
              Toast(res.message)
            }
          } else {
            document.write(res)
          }
        }
      }).catch(function (error) {
        if (error.message) {
          Toast(error.message)
        } else {
          document.write(error)
        }
      })
    },
    // 绑定邮箱
    sendVerifyCodeEmail () {
      updateUserEmail(this.email).then(res => {
        Toast(res.message)
        this.editEmailVisible = false
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style scoped lang='scss'>
    .container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: $mainbgColor;
    }
    .top-wrapper {
        height: 6rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
        margin-bottom: 0;
        border-bottom: 1px solid #b8c0cc;
    }
    .row-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .title-wrapper {
        height: 3.2rem;
    }
    .subtitle-wrapper {
        height: 1.5rem;
        margin-top: 0.5rem;
    }
    .icon {
        width: 0.9rem;
        height: 0.9rem;
        margin-left: 0.8rem;
        margin-right: 0.5rem;
    }
    .title {
        font-size: 0.8rem;
        color: #3C3C3C;
    }
    .subtitle {
        font-size: 0.8rem;
        color: #4D4D4D;
        margin-left: 2.5rem;
    }
    .price {
        font-size: 0.8rem;
        color: $primaryColor;
    }
    .item-wrapper{
        height: 3.1rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background-color: #fff;
        border-bottom: 1px solid #b8c0cc;
    }
    .item-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
    }
    .item-left-wrapper {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        i{background-image: url(../../../assets/image/wxpayicon.png);background-repeat: no-repeat;background-size: 100%;}
        .alipay_h5,.alipay_app{background-image: url(../../../assets/image/alipayicon.jpg);background-repeat: no-repeat;background-size: 100%; }
    }
    .stripe-list-logo {
        display: inline-block;
        min-width: 2.4rem;
        margin-left: 0.8rem;
        margin-right: 0.5rem;
        color: #635bff;
        font-size: 0.9rem;
        font-weight: 700;
        letter-spacing: -0.04rem;
    }
    .stripe-payment-options {
        margin: 0;
        color: #32325d;
        background: $mainbgColor;
        font-size: 0.72rem;
        line-height: 1.5;
        h4 {
            margin: 0 0 0.6rem;
            font-size: 0.82rem;
        }
    }
    .stripe-progress-panel,
    .stripe-plan-setup,
    .stripe-checkout-panel {
        padding: 0.85rem;
        border: 0;
        border-radius: 0;
        background: #fff;
        box-shadow: none;
    }
    .stripe-progress-panel,
    .stripe-plan-setup {
        margin-bottom: 0;
        border-bottom: 1px solid #b8c0cc;
    }
    .stripe-section-heading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.65rem;
        h4 {
            margin: 0;
        }
        span {
            padding: 0.14rem 0.45rem;
            border-radius: 0.7rem;
            color: #27834c;
            background: #eaf8ef;
            font-size: 0.62rem;
            font-weight: 600;
        }
    }
    .stripe-progress-track {
        display: flex;
        width: 100%;
        height: 0.65rem;
        overflow: hidden;
        border-radius: 0.35rem;
        background: #e8ecf3;
        box-shadow: inset 0 0 0 1px rgba(50, 50, 93, 0.08);
    }
    .stripe-progress-fill {
        height: 100%;
        border-radius: inherit;
        background: linear-gradient(90deg, #26a95c, #42c979);
        transition: width 0.3s ease;
    }
    .stripe-mode-option {
        display: block;
        margin: 0.45rem 0;
    }
    .stripe-installment-config {
        margin-top: 0.75rem;
        padding-top: 0.65rem;
        border-top: 1px solid #b8c0cc;
        label {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0.55rem 0;
        }
        select {
            min-width: 7.5rem;
            padding: 0.32rem;
            border: 1px solid #cbd4e1;
            border-radius: 0.2rem;
            background: #fff;
        }
    }
    .stripe-installment-preview {
        margin: 0.65rem 0 0;
    }
    .stripe-plan-items {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0.45rem;
        margin-top: 0.65rem;
    }
    .stripe-plan-item {
        position: relative;
        display: flex;
        align-items: center;
        min-width: 0;
        padding: 0.48rem;
        border: 1px solid #dfe3eb;
        border-radius: 0.3rem;
        background: #f8f9fb;
    }
    .stripe-plan-index {
        flex: 0 0 1.1rem;
        width: 1.1rem;
        height: 1.1rem;
        margin-right: 0.38rem;
        border-radius: 50%;
        color: #667085;
        line-height: 1.1rem;
        text-align: center;
        background: #e3e7ee;
        font-size: 0.62rem;
        font-weight: 700;
    }
    .stripe-plan-copy {
        min-width: 0;
        span,
        strong {
            display: block;
        }
        span {
            color: #667085;
            font-size: 0.58rem;
            white-space: nowrap;
        }
        strong {
            color: #32325d;
            font-size: 0.68rem;
        }
    }
    .stripe-plan-status {
        position: absolute;
        top: -0.32rem;
        right: 0.25rem;
        padding: 0.06rem 0.28rem;
        border-radius: 0.5rem;
        color: #667085;
        background: #e8ecf3;
        font-size: 0.5rem;
    }
    .stripe-plan-item-paid {
        border-color: #a9dfbd;
        background: #f1fbf5;
        .stripe-plan-index,
        .stripe-plan-status {
            color: #fff;
            background: #31b66b;
        }
    }
    .stripe-plan-item-current {
        border-color: #aaa6ff;
        background: #f5f4ff;
        .stripe-plan-index,
        .stripe-plan-status {
            color: #fff;
            background: #635bff;
        }
    }
    .stripe-checkout-panel {
        background: #fff;
    }
    .stripe-current-payment {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.7rem;
        border: 1px solid #c9c6ff;
        border-radius: 0.35rem;
        background: #f1f0ff;
        .stripe-current-label,
        strong,
        small {
            display: block;
        }
        .stripe-current-label {
            color: #667085;
            font-size: 0.62rem;
        }
        strong {
            margin: 0.05rem 0;
            color: #32325d;
            font-size: 1.15rem;
            line-height: 1.25;
        }
        small {
            color: #667085;
            font-size: 0.58rem;
        }
    }
    .stripe-due-badge {
        padding: 0.2rem 0.48rem;
        border-radius: 0.7rem;
        color: #fff;
        background: #635bff;
        font-size: 0.58rem;
        font-weight: 600;
    }
    .stripe-card-panel {
        margin-top: 0.7rem;
        padding: 0.7rem;
        border: 1px solid #e0e5ed;
        background: #fff;
        border-radius: 0.35rem;
        h4 {
            margin-bottom: 0.25rem;
        }
    }
    .stripe-inline-hint,
    .stripe-payment-message {
        margin: 0 0 0.55rem;
        color: #667085;
    }
    .stripe-payment-message {
        min-height: 1.1rem;
        margin-top: 0.55rem;
    }
    .stripe-inline-error {
        color: #d63638;
    }
    .item-right-wrapper {
        flex: 0 0 2.5rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }
    .item-title {
        font-size: 0.8rem;
        color: #3C3C3C;
        white-space: nowrap;
    }
    .item-subtitle {
        font-size: 0.8rem;
        color: #8C8C8C;
        margin-right:0.25rem;
        text-align: right;
    }
    .item-select {
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 1.1rem;
    }
    .indicator {
        width: 0.7rem;
        height: 0.7rem;
        margin-left:0.25rem;
        margin-right: 0.8rem;
    }
    .action-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 2.5rem;
        margin-top: 2.25rem;
    }
</style>
